
  import { defineComponent, ref, reactive, toRefs, inject, unref, onMounted } from 'vue';
  import { ErrorMessage, Field, Form } from 'vee-validate';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useStore } from 'vuex';
  import { useRouter } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import Swal from 'sweetalert2/dist/sweetalert2.min.js';
  import { hideModal } from '@/core/helpers/dom';
  import * as Yup from 'yup';
  import flatPickr from 'vue-flatpickr-component';
  import 'flatpickr/dist/flatpickr.css';
  import { Modal } from 'bootstrap';
  import VOtpInput from 'vue3-otp-input';
  import AOS from 'aos';
  import StorageService from '@/core/services/StorageService';
  import JwtService from '@/core/services/JwtService';

  export default defineComponent({
    name: 'sign-in',
    components: {
      Field,
      Form,
      flatPickr,
      ErrorMessage,
    },
    setup(props, context) {
      const helpers: any = inject('helpers');
      const store = useStore();
      const router = useRouter();
      const i18n = useI18n();
      const { t } = useI18n();
      let formRef = ref<HTMLElement | null>(null);
      let formRefOTP = ref<HTMLElement | null>(null);
      let createAppModalRef = ref<HTMLElement | null>(null);
      let thisModalObj: any = null;
      let REGISTER_AUTH: any = StorageService.getStorageService('REGISTER_AUTH');

      const submitButton = ref<HTMLElement | null>(null);
      const submitButtonOTP = ref<HTMLElement | null>(null);
      const otpInput = ref<InstanceType<typeof VOtpInput> | null>(null);
      const bindValue = ref('');

      onMounted(() => {
        AOS.init();
        console.log(Modal);
        thisModalObj = new Modal(createAppModalRef.value, { backdrop: 'static', keyboard: false });
        // if (thisModalObj) {
        //   thisModalObj.show();
        // }
        if (JwtService.getToken()) {
          router.push({ name: 'auth_403' });
        }
        if (REGISTER_AUTH) {
          // router.push({name: 'complete_register_page', params: {token: REGISTER_AUTH}});
        }
      });

      const state = reactive({
        login_method: 'email',
        sendBy: 'sms',
        auth_method: 'egy',

        isCheckedPassword: false,
        isNewUser: 0,
        hasPassword: false,
        isVerified: false,
        isRunningOTP: false,
        interval: '02:00',

        ImageModel: null,
        ImageLoaderProgress: 0,
        ImageLoader: false,

        ssn: null,
        phone: null,
        email: null,
        password: null,
        password_confirmation: null,
      });


      //Form submit function
      const onSubmitLogin = (values, form) => {
        if (!form) {
          return;
        }

        const { setErrors } = form;

        if (!state.isCheckedPassword) {
          checkPassword();
          return;
        }

        if (!state.isVerified) {
          sendOTP();
          return;
        }
        //
        // let _REGISTER_AUTH: any = StorageService.getStorageService('REGISTER_AUTH');
        // if (_REGISTER_AUTH) {
        //     router.push({name: 'complete_register_page', params: {token: _REGISTER_AUTH}});
        // }
      };

      const onSubmitOTP = (values, form) => {
        // Clear existing errors

        if (!form) {
          return;
        }

        if (submitButtonOTP.value) {
          // Activate indicator
          submitButtonOTP.value.setAttribute('data-kt-indicator', 'on');
          submitButtonOTP.value.setAttribute('disabled', 'true');
        }

        const { setErrors } = form;

        // Dummy delay
        // Send login request
        let payload = {
          'countryCode': '20',
          'phoneNumber': state.phone,
          'nationalId': state.ssn,
          'email': state.email,
          'login_method': state.login_method,
          'insideEgypt': state.auth_method == "egy" ? 1 : 0,
          'bindValue': bindValue,
          'otpValue': unref(bindValue),
        };
        if (state.password){
          payload['password'] = state.password;
        }
        store
          .dispatch('moduleAuth/checkOTP', payload)
          .then((response) => {
            // state.isVerified = true;

            if (thisModalObj) thisModalObj.hide();
            let data = response.data.data;

            if (data.user) {
              router.push({ name: 'all_programs_page' }).then(() => {
                location.reload();
              });
            } else {
              router.push({ name: 'complete_register_page', params: { token: data.accessToken } }).then(() => {
                location.reload();
              });
            }

            // onSubmitLogin([], unref(formRef));

            //Deactivate indicator
            submitButtonOTP.value?.removeAttribute('data-kt-indicator');
            submitButtonOTP.value?.removeAttribute('disabled');
          })
          .catch((response) => {
            if (!helpers) {
              return;
            }
            helpers.handleResponse(response, t, router, store, { setErrors });
            //Deactivate indicator
            submitButtonOTP.value?.removeAttribute('data-kt-indicator');
            submitButtonOTP.value?.removeAttribute('disabled');
          });

      };

      const sendOTP = () => {
        if (state.isRunningOTP) return;
        if (submitButton.value) {
          // Activate indicator
          submitButton.value.setAttribute('data-kt-indicator', 'on');
          submitButton.value.setAttribute('disabled', 'true');
        }

        if (state.login_method == 'phone') {
          let payload = {
            'countryCode': '20',
            'phoneNumber': state.phone,
            'nationalId': state.ssn,
            'insideEgypt': state.auth_method == "egy" ? 1 : 0,
          };
          if (state.password){
            payload['password'] = state.password
          }
          if (state.login_method == "phone"){
            payload['sendBy'] = state.sendBy;
          }
          store
            .dispatch('moduleAuth/sendOTP', payload)
            .then((response) => {
              if (response.token){
                setTimeout(()=>{
                  router.push({ name: 'dashboard' }).then(() => {
                    location.reload();
                  });
                },1000)
                return;
              }
              if (thisModalObj) thisModalObj.show();
              startTimer();
              //TODO:: auth auto fill opt
              // fillInput(response.otpValue)
              if (submitButton.value) {
                // Activate indicator
                submitButton.value?.removeAttribute('data-kt-indicator');
                submitButton.value?.removeAttribute('disabled');
              }
            })
            .catch((response) => {
              if (!helpers) {
                return;
              }
              if (submitButton.value) {
                // Activate indicator
                submitButton.value?.removeAttribute('data-kt-indicator');
                submitButton.value?.removeAttribute('disabled');
              }
              helpers.handleResponse(response, t, router, store, {});
            });
        }
        if (state.login_method == 'email') {

          let payload = {
            'email': state.email,
            'nationalId': state.ssn,
            'insideEgypt': state.auth_method == "egy" ? 1 : 0,
          };
          if (state.password){
            payload['password'] = state.password
          }
          store
            .dispatch('moduleAuth/sendOTPEmail', payload)
            .then((response) => {
              console.log(response)
              state.isNewUser = response.isNewUser || 0;
              if (response.token){
                setTimeout(()=>{
                  router.push({ name: 'dashboard' }).then(() => {
                    location.reload();
                  });
                },1000)
                return;
              }
              if (thisModalObj) thisModalObj.show();
              startTimer();
              //TODO:: auth auto fill opt
              // fillInput(response.otpValue)
              if (submitButton.value) {
                // Activate indicator
                submitButton.value?.removeAttribute('data-kt-indicator');
                submitButton.value?.removeAttribute('disabled');
              }
            })
            .catch((response) => {
              if (!helpers) {
                return;
              }
              if (submitButton.value) {
                // Activate indicator
                submitButton.value?.removeAttribute('data-kt-indicator');
                submitButton.value?.removeAttribute('disabled');
              }
              helpers.handleResponse(response, t, router, store, {});
            });
        }

      };

      const checkPassword = () => {
        if (submitButton.value) {
          // Activate indicator
          submitButton.value.setAttribute('data-kt-indicator', 'on');
          submitButton.value.setAttribute('disabled', 'true');
        }

          let payload = {
            'email': state.email,
            'nationalId': state.ssn,
            'insideEgypt': state.auth_method == "egy" ? 1 : 0,
          };
          store
            .dispatch('moduleAuth/checkPassword', payload)
            .then((response) => {
              state.isCheckedPassword = true;
              state.hasPassword = response.data.data.hasPassword || false;
              if (submitButton.value) {
                // Activate indicator
                submitButton.value?.removeAttribute('data-kt-indicator');
                submitButton.value?.removeAttribute('disabled');
              }
              if (!(response.data.data.hasPassword || false)){
                onSubmitLogin([], unref(formRef));
              }
            })
            .catch((response) => {
              if (!helpers) {
                return;
              }
              if (submitButton.value) {
                // Activate indicator
                submitButton.value?.removeAttribute('data-kt-indicator');
                submitButton.value?.removeAttribute('disabled');
              }
              helpers.handleResponse(response, t, router, store, {});
            });

      };

      const handleOnComplete = (value: string) => {
        if (!formRefOTP.value) {
          return;
        }
        if (state.isCheckedPassword && !state.hasPassword){
          return;
        }
        onSubmitOTP([], unref(formRefOTP));
      };
      const fillInput = (value) => {
        otpInput.value?.fillInput(value);
      };

      const resendOTP = () => {
        sendOTP();
      };
      const checkSecond = (sec) => {
        if (sec < 10 && sec >= 0) {
          sec = '0' + sec;
        }
        if (sec < 0) {
          sec = '59';
        }
        return sec;
      };
      const startTimer = () => {
        var presentTime = state.interval;
        var timeArray: any = presentTime.split(/[:]+/);
        var m = timeArray[0];
        var s = checkSecond((timeArray[1] - 1));
        if (s == 59) {
          m = m - 1;
        }
        if ((m + '').length == 1) {
          m = '0' + m;
        }
        if (m < 0) {
          m = '59';
        }
        state.interval = m + ':' + s;
        if (!(m == '00' && s == '00')) {
          setTimeout(startTimer, 1000);
        } else {
          state.isRunningOTP = false;
        }
      };

      return {
        submitButtonOTP,
        onSubmitOTP,
        resendOTP,
        handleOnComplete,
        otpInput, bindValue,
        formRefOTP,

        ...toRefs(state),
        onSubmitLogin, i18n,
        createAppModalRef,
        formRef,
        submitButton,
      };
    },
  });
